import { createActionTypes } from "@src/utility"

export const DEPARTMENT_TYPES = createActionTypes("department", [
  "GET_ALL_DEPARTMENTS_REQUEST",
  "GET_ALL_DEPARTMENTS_SUCCESS",
  "GET_ALL_DEPARTMENTS_FAIL",

  "CREATE_DEPARTMENT_REQUEST",
  "CREATE_DEPARTMENT_SUCCESS",
  "CREATE_DEPARTMENT_FAIL",
  
  "UPDATE_DEPARTMENT_REQUEST",
  "UPDATE_DEPARTMENT_SUCCESS",
  "UPDATE_DEPARTMENT_FAIL",
  
  "DELETE_DEPARTMENT_REQUEST",
  "DELETE_DEPARTMENT_SUCCESS",
  "DELETE_DEPARTMENT_FAIL"
])
